<template>
    <div class="detail-header">
        <div v-if="firstItem" class="detail-header__back">
            <BaseIcon icon="back" @click="goBack" id="test-button-back-to-dashboard" />
        </div>
        <div class="detail-header__info" v-bind:class="{'detail-header__info__margin':!firstItem}">
            <div class="detail-header__status" v-bind:style="{ backgroundColor: bColor }"></div>
            <div class="detail-header__title-wrapper">
                <div v-if="unit.name" class="detail-header__title" v-responsive.lg.xl.md.sm.xs>{{ unit.name }}</div>
                <div v-else class="detail-header__title placeholder">-place for name-</div>

                <div class="detail-header__subtitle">
                    <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.type') }}: </span>
                    <span id="test-output-unit-name" style="font-weight: 500">{{unit.typeName}}</span>
                    <div class="divider"></div>
                    <span v-responsive.xl.lg.md.sm>{{ $t('dashboard.nav.remark') }}: </span>
                    <span id="test-output-unit-remark" style="font-weight: 500">{{unit.remark ? compLocation : ''}}</span>
                </div>
            </div>
            <div v-if="configItem" class="detail-header__edit" v-click-outside="hideEditForm">
                <BaseIcon icon="edit" @click="toggleEditForm" class="test-detail-button-edit" />
                <transition name="fadeUp">
                    <div v-if="showEditForm" class="detail-header__edit__form">
                        <div class="triangle"></div>
                        <BaseInput :label="$t('tooltips.unit_name')" v-model="editName" />
                        <BaseInput :label="$t('dashboard.nav.remark')" v-model="editRemark" />
                        <div class="flex">
                            <BaseButton @click.native="save" style="margin-left: auto;">
                                {{ $t('buttons.save') }}
                            </BaseButton>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
	import {mapGetters} from 'vuex';

	export default {
		name: 'DetailHeader',
		props: {
			unit: Object,
			color: String,
			firstItem: {
				type: Boolean,
				default: true,
			},
			configItem: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				bColor: this.color,
				editName: this.unit.name,
				editRemark: this.unit.remark,
				showEditForm: false,
			};
		},
		computed: {
			compLocation() {
				return (this.unit.remark.length > 23) ? `${this.unit.remark.substring(0, 20)}...` : this.unit.remark;
			},
			...mapGetters('tentacle', ['type']),
		},
		methods: {
			updateTentacles(data) {
				this.$store.dispatch('tentacle/updateUnit', data).then((response) => {
					if (response.status === 200) {
						this.flash('Tentacles updated', 'success');
					}
				});
			},
			toggleEditForm() {
				this.showEditForm = !this.showEditForm;
			},
			hideEditForm() {
				this.showEditForm = false;
			},
			save() {
				this.updateTentacles([{id: this.unit.id, name: this.editName, remark: this.editRemark}]);
				this.hideEditForm();
			},
			goBack() {
				this.$router.push({name: 'dashboard', params: {lang: this.$i18n.locale.toLowerCase(), type: this.type.urlSlug}})
			}
		},
	};
</script>

<style lang="scss" scoped>
    .detail-header {
        height: 8rem;
        display: flex;
        align-items: stretch;

        &__back {
            align-self: center;
            width: 8rem;
            display: flex;
            justify-content: center;
            cursor: pointer;

            svg {
                fill: $grey;
                transition: all 0.4s;
            }

            &:hover {
                .icon {
                    fill: $company-color;
                }
            }
        }

        &__info {
            display: flex;
            align-items: center;
            &__margin {
                margin-left: 8em;
            }
        }

        &__status {
            height: 1rem;
            width: 1rem;
            border-radius: 50%;
        }

        &__title-wrapper {
            margin: 0 2rem;

            .placeholder {
                color: rgba(172, 180, 197, 0.26)
            }
        }

        &__title {
            font-weight: 700;
            font-size: 2.2rem;
            color: $dark;
            word-wrap: break-word;
            max-width: 55vw;
            @media only screen and (min-width: 1199px) {
                max-width: 25vw;
            }
        }

        &__subtitle {
            margin-top: 0.3rem;
            color: $grey;
            font-size: 1.2rem;
            font-weight: 600;
            display: flex;
            span {
                font-weight: 400;
                margin-right: 0.25em;
            }
            .divider {
                align-self: stretch;
                width: 0.1rem;
                background-color: #dbd8ff;
                margin: 0 1rem;
            }
        }

        &__edit {
            cursor: pointer;
            position: relative;

            &:hover {
                .icon {
                    fill: $company-color;
                }
            }

            .icon {
                width: 2rem;
                height: 2rem;
                fill: $grey;
                transition: all 0.4s;
            }

            .triangle {
                position: absolute;
                top: -1.2rem;
                left: 1rem;
                margin: 0 auto;
                width: 0;
                height: 0;
                border-left: 1rem solid transparent;
                border-right: 1rem solid transparent;
                border-bottom: 1.2rem solid white;
                @media only screen and (max-width: 991px) {
                    left: 15rem;
                }
            }

            &__form {
                z-index: 3;
                top: 3.3rem;
                left: -1.5rem;
                position: absolute;
                display: block;
                padding: 1rem;
                width: 30rem;
                height: 22rem;
                background-color: white;
                box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
                0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
                @media only screen and (max-width: 991px) {
                    top: 4.5rem;
                    left: -30.5rem;
                }
            }
        }
    }
</style>
